export function isInternalWithSubdomain(href: string) {
  return /.*\.housinganywhere\.com/.test(href);
}
